import {
    Bar,
    BarChart,
    CartesianGrid,
    Legend,
    Tooltip,
    XAxis,
    YAxis,
    ResponsiveContainer,
    LabelList,
} from "recharts";
import {
    CustomLegend,
    CustomTooltip,
} from "../reusables/ReusableChartComponents";
import { KPI_TEXT } from "../../../../../data/enums";

interface BarData {
    name: string;
    [KPI_TEXT.CURRENT]: number;
    [KPI_TEXT.REMAINING]: number;
    target_value: number;
}

interface BarComponentProps {
    data: BarData[];
    primaryColor: string;
    secondaryColor: string;
}

export const BarComponent = ({
    data,
    primaryColor,
    secondaryColor,
}: BarComponentProps) => {
    const CustomLabel = (props: any) => {
        const { x, y, width, value, index } = props;
        const dataItem = data[index];
        const percentage = (
            dataItem[KPI_TEXT.CURRENT] / dataItem.target_value
        ).toFixed(2);

        return (
            <text
                x={x + width / 2}
                y={y - 5}
                fill="#000"
                fontSize={14}
                textAnchor="middle"
            >
                {percentage}
            </text>
        );
    };

    return (
        <ResponsiveContainer width="100%" height={510}>
            <BarChart data={data} maxBarSize={100}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis
                    domain={[0, (dataMax: any) => dataMax * 1.2]}
                    allowDataOverflow={true}
                />
                <Tooltip
                    content={<CustomTooltip />}
                    cursor={{ fill: "#f0f0f0" }}
                />
                <Legend content={<CustomLegend />} />
                <Bar
                    dataKey={KPI_TEXT.CURRENT}
                    stackId="a"
                    fill={primaryColor}
                ></Bar>
                <Bar
                    dataKey={KPI_TEXT.REMAINING}
                    stackId="a"
                    fill={secondaryColor}
                >
                    <LabelList
                        dataKey={KPI_TEXT.REMAINING}
                        content={<CustomLabel />}
                    />
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
};
